/* ----------------------------------------------------------
POLÍTIA DE COOKIES
-------------------------------------------------------------*/

var Header = function()
{
    function horario()
    {
        var request = $.ajax({
            url:'/api/header/horario',
            dataType: "json"
        });

        request.done(function(result,statusText,xhr)
        {
            if(xhr.status == 200)
            {
                $("#headerHorarioTxt").html(result.Data)
            }
            else
            {
                console.error(statusText);
                console.error(xhr);
            }
        });
    }
    
    horario();    
}